import { routes } from "../routesConfig";

const LANGS = ["es", "en"];

// Quita el prefijo de idioma: "/en/iniciar-sesion" -> "/iniciar-sesion"
function stripLang(pathname = "") {
  const parts = pathname.split("/").filter(Boolean);
  if (LANGS.includes(parts[0])) parts.shift();
  return "/" + parts.join("/");
}

// "/viajes/:slug" -> /^\/viajes\/([^/]+)$/ + ["slug"]
function patternToRegex(pattern) {
  const names = [];
  const source = pattern
    .split("/")
    .map((seg) => {
      if (!seg) return "";
      if (seg.startsWith(":")) {
        names.push(seg.slice(1));
        return "([^/]+)";
      }
      return seg.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    })
    .join("/");
  return { regex: new RegExp(`^${source}/?$`, "i"), names };
}

// Los patrones con más tramos primero: "/trips/in/:city" debe ganar a
// "/trips/:slug", que si no se comería la parte "in".
function orderedEntries(lang) {
  return Object.entries(routes[lang] || {})
    .map(([key, pattern]) => [key, stripLang(pattern)])
    .sort((a, b) => b[1].split("/").length - a[1].split("/").length);
}

/**
 * Busca a qué ruta de routesConfig corresponde un pathname, mirando el
 * slug y no el prefijo de idioma (el selector de idioma cambia el prefijo
 * pero deja el slug del idioma anterior).
 * Devuelve { key, params } o null si la ruta no está en routesConfig.
 */
function matchRoute(pathname) {
  const rest = stripLang(pathname);
  for (const lang of LANGS) {
    for (const [key, pattern] of orderedEntries(lang)) {
      const { regex, names } = patternToRegex(pattern);
      const m = rest.match(regex);
      if (m) {
        const params = {};
        names.forEach((name, i) => {
          params[name] = m[i + 1];
        });
        return { key, params };
      }
    }
  }
  return null;
}

/**
 * Traduce una ruta al idioma indicado conservando sus parámetros.
 * "/es/viajes/roma-123" + "en" -> "/en/trips/roma-123"
 * "/en/iniciar-sesion"  + "en" -> "/en/login"
 * Devuelve null si la ruta no está en routesConfig (perfiles /u/:username,
 * PDFs…) o si ya es correcta: esas se dejan tal cual.
 */
export function translatePath(pathname, toLang) {
  if (!pathname || !LANGS.includes(toLang)) return null;

  const found = matchRoute(pathname);
  if (!found) return null;

  let target = routes[toLang]?.[found.key];
  if (!target) return null;

  Object.entries(found.params).forEach(([name, value]) => {
    target = target.replace(`:${name}`, value);
  });
  // Al destino le faltan parámetros que el origen no aporta: mejor no tocar
  if (target.includes("/:")) return null;

  return target === pathname ? null : target;
}
